<h2 class="sr-only">{{ "EGBTBIDSuche" | translate }}</h2>
<form (ngSubmit)="onSubmit()" [meta]="egbtbid" #form="ngForm">
  <cap-form-row column-classes="col-md-2,col-md-3">
    <cap-form-control invalidKey="EingabeMussValideEgbtbidSein" labelKey="EGBTBID">
      <input
        (ngModelChange)="egbtbid && egbtbid.egbtbid && (egbtbid.egbtbid.value = $event)"
        [ngModel]="egbtbid && egbtbid.egbtbid && egbtbid.egbtbid.value"
        #EGBTBID
        #ereid
        appAutofocus
        id="egbtbid"
        name="egbtbid.egbtbid.value"
        required
        type="text" />
    </cap-form-control>
  </cap-form-row>

  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset(EGBTBID)" class="btn btn-outline-primary btn-actionpane" type="button">
        {{ "Zurücksetzen" | translate }}
      </button>
      <button [disabled]="!form.form.valid || !egbtbid" class="btn btn-primary btn-actionpane" type="submit">
        {{ "Suche" | translate }}
      </button>
    </div>
  </div>
</form>
